import { render } from "./ManagePost.vue?vue&type=template&id=0cdf191d&scoped=true"
import script from "./ManagePost.vue?vue&type=script&lang=js"
export * from "./ManagePost.vue?vue&type=script&lang=js"

import "./ManagePost.vue?vue&type=style&index=0&id=0cdf191d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cdf191d"]])

export default __exports__